import { Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { redirectToLogin } from '@/lib/http';
import { getAppContext } from '@/lib/app-context';

/**
 * 未登录时的落地页。
 *
 * 之前没有这个页面：未登录访问会先白屏，再渲染一层空界面，
 * 直到某个业务接口回 401 才被动跳走，中途没有任何解释。
 * 现在改成显式的一页，点按钮才去飞书，失败了也还留在本站。
 */
const LoginPage: React.FC = () => {
  const appName: string = getAppContext().appName;

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background px-4">
      <Card className="w-full max-w-[380px]">
        <CardContent className="flex flex-col items-center gap-6 px-6 py-10">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
            <Sparkles className="h-6 w-6 text-primary" />
          </div>
          <div className="flex flex-col items-center gap-1 text-center">
            <h1 className="text-xl font-semibold text-foreground">{appName}</h1>
            <p className="text-sm text-muted-foreground">
              团队 AI 资产控制台，请用企业飞书账号登录
            </p>
          </div>
          <Button className="h-11 w-full text-base" onClick={redirectToLogin}>
            用飞书登录
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            登录后可以看到分配给自己的账号；
            <br />
            没有权限或提示账号已停用时，请联系管理员。
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
